import service from "@/api/service";
import { GetResponse } from "@/api/menu-category-preview/response";
import { GetRequest } from "@/api/menu-category-preview/request";

/**
 * メニューカテゴリ一覧プレビューAPIをコールします。
 *
 * @return GetResponse
 */
export async function get(getRequest: GetRequest) {
  const response = await service.post("/preview-menu-category", getRequest);
  return response.data as GetResponse;
}
